import service from '../service.js'

export default {
    /**
     * 添加工厂信息
     * @param {*} factoryName 
     * @param {*} companyId 
     * @returns 
     */
    AddFactories: (factoryName, companyId) => {
        return service({
            url: '/Factories/AddFactories',
            method: 'post',
            params: { factoryName, companyId }
        })
    },
    /**
     * 根据公司id获取工厂信息
     * @param {*} companyId 
     * @returns 
     */
    GetFactories: (companyId) => {
        return service({
            url: '/Factories/GetFactories',
            method: 'get',
            params: { companyId }
        })
    },
    /**
     *  删除工厂信息
     * @param {*} factoryId 
     * @returns 
     */
    DeleteFactories: (factoryId) => {
        return service({
            url: '/Factories/DeleteFactories',
            method: 'post',
            params: { factoryId }
        })
    },
}